export default __webpack_public_path__ + "static/SuisseIntl-Bold-66a4e4e2543519682499bb4751854686.woff2";